(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44912],{

/***/ 47050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11763);




var onRequest = function(config) {
    var method = config.method, headers = config.headers, url = config.url, data = config.data;
    var securitiesRefreshToken = utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSecuritiesToken */ .Z.getSecuritiesToken().securitiesRefreshToken;
    var isPostRequest = method === "POST" || method === "post";
    var isTradingAPI = url.includes(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb) || url[0] === "/";
    headers.Authorization = headers.Authorization || "Bearer ".concat(securitiesRefreshToken);
    if (isPostRequest && isTradingAPI) {
        headers["content-type"] = "application/x-www-form-urlencoded";
        // eslint-disable-next-line no-param-reassign
        config.data = qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(data);
    }
    return config;
};
var requestRefreshTrading = function() {
    var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb;
    var apiInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
        baseURL: baseURL,
        headers: {
            accept: "application/json"
        }
    });
    apiInstance.interceptors.request.use(function(config) {
        return onRequest(config);
    });
    return apiInstance;
};
/* harmony default export */ __webpack_exports__["Z"] = (requestRefreshTrading);


/***/ }),

/***/ 18364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ requestTrading; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
;// CONCATENATED MODULE: ./src/global/Securities/utils/apiBaseUrl.ts


var getSecuritiesAPIUrl = function() {
    return (0,utils/* isRedirectToNewCore */.JI)() ? api/* API_TRADING_URL_V2 */.cu : api/* API_TRADING_URL */.Cb;
};

// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/config/requestRefreshTrading.tsx
var requestRefreshTrading = __webpack_require__(47050);
;// CONCATENATED MODULE: ./src/global/Securities/api/instance/refresh.ts

var refreshApiInstance = (0,requestRefreshTrading/* default */.Z)();

;// CONCATENATED MODULE: ./src/global/Securities/api/auth.ts





var postAuthRefresh = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, axiosData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return refreshApiInstance.post("".concat(getSecuritiesAPIUrl()).concat(apiEndpoint/* authEndpoint.authRefresh */.KQ.authRefresh));
                case 2:
                    ref = _ctx.sent;
                    axiosData = ref.data;
                    return _ctx.abrupt("return", axiosData.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postAuthRefresh() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondError.ts
var useBondError = __webpack_require__(10893);
// EXTERNAL MODULE: ./src/config/requestTrading/utils.ts
var requestTrading_utils = __webpack_require__(68481);
;// CONCATENATED MODULE: ./src/config/requestTrading/errorHandler.ts













// #region error type handler
var dispatchSetErrorCode = function(param) {
    var status = param.status, message = param.message, type = param.type;
    trading/* default.getState */.Z.getState().setErrorCode(status, message, type);
};
var handleSetErrorCode = function(error) {
    var errorConfig = (0,requestTrading_utils/* getErrorConfig */.v)(error);
    dispatchSetErrorCode(errorConfig);
    return Promise.reject(error);
};
var handleNoResponse = function(error) {
    dispatchSetErrorCode({
        status: 500
    });
    return Promise.reject(error);
};
var handleShowAlertMessage = function(error, message) {
    var errorConfig = (0,requestTrading_utils/* getErrorConfig */.v)(error);
    if (message || errorConfig.message) {
        (0,AlertMessage/* default */.Z)({
            content: message || errorConfig.message,
            alertType: "plain-default",
            messageType: "error",
            hasCloseIcon: false
        });
    }
    dispatchSetErrorCode(errorConfig);
    return Promise.reject(error);
};
var handleBondsError = function(error) {
    var errorConfig = (0,requestTrading_utils/* getErrorConfig */.v)(error);
    var bondBlockerType = constants/* bondsErrorTypesMapping */.eM[errorConfig.type] || constants/* BondBlockerType.UNSPECIFIED */.Ew.UNSPECIFIED;
    if (bondBlockerType === constants/* BondBlockerType.UNSPECIFIED */.Ew.UNSPECIFIED && errorConfig.message) {
        (0,AlertMessage/* default */.Z)({
            content: errorConfig.message,
            alertType: "plain-default",
            messageType: "error",
            hasCloseIcon: false
        });
        return Promise.reject(error);
    }
    useBondError/* default.getState */.Z.getState().setErrorCode(400, errorConfig.message, errorConfig.type);
    return Promise.reject(error);
};
var badRequestHandlerList = {
    // Bonds Error handlers
    product_not_found: handleBondsError,
    price_rate_not_found: handleBondsError,
    fr_in_record_date_period: handleBondsError,
    fr_bonds_market_close: handleBondsError,
    stockbit_get_account_not_found: handleBondsError,
    trading_account_suspended: handleBondsError,
    price_has_changed: handleBondsError,
    fr_existing_order_inprogress: handleBondsError,
    portfolio_not_exist: handleBondsError,
    redeem_amount_greater_than_redeemable_amount: handleBondsError,
    not_in_secondary_market_period: handleBondsError,
    sell_order_inprogress: handleBondsError,
    user_sharia_validation: handleBondsError,
    stable_earn_cannot_be_sold_outside_bibit: handleBondsError
};
var unauthorizedHandlerList = {
    INVALID_AUTH: handleSetErrorCode,
    INVALID_TOKEN: handleSetErrorCode,
    INVALID_SESSION: handleSetErrorCode,
    MOCK_TRADING: handleSetErrorCode,
    MAINTENANCE_MODE: handleSetErrorCode,
    DAILY_MAINTENANCE_MODE: handleSetErrorCode,
    INVALID_CREDS: handleSetErrorCode,
    UNAUTHORIZED: handleSetErrorCode
};
var forbiddenErrorList = {
    USER_SUSPEND: handleSetErrorCode,
    USER_SUSPEND_BACK_OFFICE: handleSetErrorCode,
    FORBIDDEN: handleSetErrorCode
};
var serviceUnavailableHandlerList = {
    DAILY_MAINTENANCE_MODE: handleSetErrorCode,
    MAINTENANCE_MODE: handleSetErrorCode
};
var internalServerErrorHandlerList = {
    SYSTEM_ERROR: handleSetErrorCode
};
// #endregion error type handler
// #region Status Handler
var handleRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(error) {
        var ref, currentRefreshToken, ref1, accessToken, refreshToken;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ref = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken(), currentRefreshToken = ref.securitiesRefreshToken;
                    if (currentRefreshToken) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Securities refresh token is not exists");
                case 4:
                    _ctx.next = 6;
                    return postAuthRefresh();
                case 6:
                    ref1 = _ctx.sent;
                    accessToken = ref1.access_token;
                    refreshToken = ref1.refresh_token;
                    securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                        securitiesAccessToken: accessToken,
                        securitiesRefreshToken: refreshToken
                    });
                    return _ctx.abrupt("return", axios_default().request((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error.config), {
                        headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error.config.headers), {
                            Authorization: "Bearer ".concat(accessToken)
                        })
                    })).catch(function(refreshError) {
                        handleSetErrorCode(refreshError);
                        return Promise.reject(refreshError);
                    }));
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    handleSetErrorCode(error);
                    return _ctx.abrupt("return", Promise.reject(error));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function handleRefreshToken(error) {
        return _ref.apply(this, arguments);
    };
}();
var handleBadRequest = function(error) {
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = badRequestHandlerList[type];
    if (errorHandler) return errorHandler(error);
    handleShowAlertMessage(error);
    return Promise.reject(error);
};
var handleUnauthorized = function(error) {
    if (!error.response.data) return handleRefreshToken(error);
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = unauthorizedHandlerList[type];
    if (errorHandler) return errorHandler(error);
    handleShowAlertMessage(error);
    return Promise.reject(error);
};
var handleForbidden = function(error) {
    if (!error.response.data) return handleRefreshToken(error);
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = forbiddenErrorList[type];
    if (errorHandler) return errorHandler(error);
    return Promise.reject(error);
};
var handleServiceUnavailable = function(error) {
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = serviceUnavailableHandlerList[type];
    if (errorHandler) return errorHandler(error);
    handleShowAlertMessage(error, errorMessage/* default.UNKNOWN_SYSTEM_ERROR */.Z.UNKNOWN_SYSTEM_ERROR);
    return Promise.reject(error);
};
var handleInternalServerError = function(error) {
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = internalServerErrorHandlerList[type];
    if (errorHandler) return errorHandler(error);
    handleShowAlertMessage(error, errorMessage/* default.UNKNOWN_SYSTEM_ERROR */.Z.UNKNOWN_SYSTEM_ERROR);
    return Promise.reject(error);
};
// Refer here for function naming
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
var tradingErrorStatusHandlerList = {
    400: handleBadRequest,
    401: handleUnauthorized,
    403: handleForbidden,
    503: handleServiceUnavailable,
    500: handleInternalServerError
}; // #endregion Status Handler

;// CONCATENATED MODULE: ./src/config/requestTrading/constants.ts
var CUSTOM_HIDDEN_ALERT_URL = [
    "auth/pin/validate",
    "auth/v2/pin/change/new",
    "auth/v2/pin/change/confirm",
    "auth/v2/pin/reset/new",
    "auth/v2/pin/reset/confirm", 
];

;// CONCATENATED MODULE: ./src/config/requestTrading/index.ts
/* eslint-disable consistent-return */ 



// constact

// handler





var onRequest = function(config, urlEncoded) {
    var securitiesAccessToken = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken().securitiesAccessToken;
    var method = config.method, headers = config.headers, url = config.url, data = config.data, _withAccessToken = config.withAccessToken, withAccessToken = _withAccessToken === void 0 ? true : _withAccessToken;
    // assign access token
    if (securitiesAccessToken && withAccessToken) {
        headers.Authorization = "Bearer ".concat(securitiesAccessToken);
    }
    // immidiately return the config if using the new trading API
    var isTradingAPIV2 = url.includes(api/* API_TRADING_URL_V2 */.cu); // `/`
    if (isTradingAPIV2) {
        return config;
    }
    /**
   * @deprecated
   * we check wether the request is from the legacy API_TRADING_URL
   */ var isLegacyTradingAPI = url.includes(api/* API_TRADING_URL */.Cb);
    /**
   * @deprecated
   * we check wether the request using POST (post) method
   */ var isPostRequest = method === "POST" || method === "post";
    /**
   * @deprecated
   * Check if user is using the legacy API,
   * We will override the content-type header config
   */ if (isLegacyTradingAPI && isPostRequest || urlEncoded) {
        headers["content-type"] = "application/x-www-form-urlencoded";
        // eslint-disable-next-line no-param-reassign
        config.data = lib_default().stringify(data);
    }
    return config;
};
var onResponseError = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(error, isShowAlertMessage) {
        var ref, response, request, status, apiUrl, isNoNeedToRefreshToken, isHideAlertOnCustomUrl, statusHandler;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    response = error.response, request = error.request;
                    status = (0,requestTrading_utils/* getErrorConfig */.v)(error).status;
                    (0,logger/* sentryLog */.gB)({
                        scope: "server-layer",
                        level: "error",
                        httpStatusCode: status,
                        tags: [
                            {
                                title: "api-error-url",
                                value: request === null || request === void 0 ? void 0 : request.responseURL
                            },
                            {
                                title: "api-error-text",
                                value: request === null || request === void 0 ? void 0 : request.responseText
                            }, 
                        ],
                        error: error
                    });
                    if (!(!response && isShowAlertMessage)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", handleNoResponse(error));
                case 6:
                    if (!(status === 401 && (request === null || request === void 0 ? void 0 : (ref = request.responseURL) === null || ref === void 0 ? void 0 : ref.includes("auth/logout")))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject(error));
                case 8:
                    apiUrl = (0,requestTrading_utils/* getPathFromUrl */.j)(error.response.config.url);
                    isNoNeedToRefreshToken = status !== 401 && error.response.data;
                    isHideAlertOnCustomUrl = CUSTOM_HIDDEN_ALERT_URL.includes(apiUrl);
                    if (!(!isShowAlertMessage && isHideAlertOnCustomUrl && isNoNeedToRefreshToken)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject(error));
                case 13:
                    statusHandler = tradingErrorStatusHandlerList[status];
                    if (!statusHandler) {
                        _ctx.next = 16;
                        break;
                    }
                    return _ctx.abrupt("return", statusHandler(error));
                case 16:
                    return _ctx.abrupt("return", handleShowAlertMessage(error));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function onResponseError(error, isShowAlertMessage) {
        return _ref.apply(this, arguments);
    };
}();
var request = function() {
    var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : api/* API_TRADING_URL */.Cb, isShowAlertMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, urlEncoded = arguments.length > 2 ? arguments[2] : void 0;
    var apiInstance = axios_default().create({
        baseURL: baseURL,
        headers: {
            accept: "application/json"
        }
    });
    apiInstance.interceptors.request.use(function(config) {
        return onRequest(config, urlEncoded);
    });
    apiInstance.interceptors.response.use(function(response) {
        return response;
    }, function(error) {
        return onResponseError(error, isShowAlertMessage);
    });
    return apiInstance;
};
/* harmony default export */ var requestTrading = (request);


/***/ }),

/***/ 68481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getPathFromUrl; },
/* harmony export */   "v": function() { return /* binding */ getErrorConfig; }
/* harmony export */ });
var getErrorConfig = function(error) {
    var ref = error.response || {}, data = ref.data, status = ref.status;
    var ref1 = data || {}, type = ref1.error_type, message = ref1.message;
    return {
        status: status,
        type: type,
        message: message
    };
};
var getPathFromUrl = function(url) {
    try {
        var urlObj = new URL(url);
        var pathname = urlObj.pathname;
        var pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/");
        return pathParts.join("/");
    } catch (error) {
        return null;
    }
};


/***/ }),

/***/ 83153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ CORPORATE_ACTION_STOCK_TYPE; },
/* harmony export */   "FA": function() { return /* binding */ UserTargetAPI; },
/* harmony export */   "Ik": function() { return /* binding */ LOT_ORDER_LIMIT; },
/* harmony export */   "Jm": function() { return /* binding */ ORDER_TYPE; },
/* harmony export */   "L2": function() { return /* binding */ STOCK_TYPE; },
/* harmony export */   "PX": function() { return /* binding */ ORDER_STATUS_COLOR; },
/* harmony export */   "cD": function() { return /* binding */ ORDER_EXPIRY_TEXT; },
/* harmony export */   "dB": function() { return /* binding */ CorporateActionStockType; },
/* harmony export */   "pr": function() { return /* binding */ SPLIT_ORDER_LOT; },
/* harmony export */   "x4": function() { return /* binding */ BUY_ORDER_TYPE_TEXT; }
/* harmony export */ });
/* unused harmony exports BOARD_TYPE, DEPOSIT_OTHER_BANK_CODE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var BOARD_TYPE = {
    saham: "RG",
    right: "TN"
};
var STOCK_TYPE = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf",
    bond: "bond"
};
var ORDER_TYPE = {
    BUY: "BUY",
    SELL: "SELL",
    AMEND_BUY: "AMEND_BUY",
    AMEND_SELL: "AMEND_SELL",
    EXERCISE: "EXERCISE",
    VIRTUAL_BUY: "VIRTUAL_BUY",
    VIRTUAL_SELL: "VIRTUAL_SELL",
    VIRTUAL_AMEND_BUY: "VIRTUAL_AMEND_BUY",
    VIRTUAL_AMEND_SELL: "VIRTUAL_AMEND_SELL",
    BOND: "BOND_TRANSACTION"
};
var ORDER_EXPIRY_TEXT = {
    gfd: "Good For Day",
    gtc: "Good Till Cancelled",
    gtcSixMonth: "Good Till Cancelled (6 Months)"
};
var BUY_ORDER_TYPE_TEXT = {
    LO: "Limit Order",
    AB: "Auto Buy"
};
var CORPORATE_ACTION_STOCK_TYPE = [
    "WARAN",
    "RIGHT",
    "ETF"
];
var DEPOSIT_OTHER_BANK_CODE = "999";
var ORDER_STATUS_COLOR = {
    order: {
        open: "#00ab6b",
        active: "#00ab6b",
        pending: "#00ab6b",
        ready: "#00ab6b",
        partial: "#00ab6b",
        "request amend": "#333333",
        amended: "#333333",
        "request cancel": "#333333",
        withdrawn: "#333333",
        match: "#333333",
        rejected: "#EE4A49"
    },
    exercise: {
        success: "#333333",
        processed: "#00ab6b",
        pending: "#00ab6b",
        rejected: "#EE4A49"
    }
};
var UserTargetAPI;
(function(UserTargetAPI) {
    UserTargetAPI["LEGACY"] = "1";
    UserTargetAPI["NEW_CORE"] = "2";
})(UserTargetAPI || (UserTargetAPI = {}));
var _obj;
var LOT_ORDER_LIMIT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "1", 999999), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "2", 9999999), _obj);
var SPLIT_ORDER_LOT = 50000;
var CorporateActionStockType = [
    STOCK_TYPE.waran,
    STOCK_TYPE.right,
    STOCK_TYPE.etf, 
];


/***/ }),

/***/ 4621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ getTargetAPI; },
/* harmony export */   "JI": function() { return /* binding */ isRedirectToNewCore; },
/* harmony export */   "TW": function() { return /* binding */ generateUiRef; },
/* harmony export */   "kk": function() { return /* binding */ getRoundDownValue; },
/* harmony export */   "yM": function() { return /* binding */ setTargetAPI; }
/* harmony export */ });
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);

var getTargetAPI = function() {
    var target = localStorage.getItem("securitiesTarget");
    return target || constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.LEGACY */ .FA.LEGACY;
};
var setTargetAPI = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.LEGACY */ .FA.LEGACY;
    localStorage.setItem("securitiesTarget", target);
    return target;
};
var isRedirectToNewCore = function() {
    return getTargetAPI() === constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE;
};
var generateUiRef = function() {
    var result = "";
    var length = 13;
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var charactersLength = characters.length;
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < length; i++){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return "W".concat(Date.now()).concat(result);
};
/**
 *
 * @param balanceValue - balance value number
 * @param fraction - fraction number
 * @returns
 * @example
 * getRoundDownValue(12345, 2) => 12345
 * getRoundDownValue(12345.6789, 2) => 12345.67
 * getRoundDownValue(12345.6789, 3) => 12345.678
 */ var getRoundDownValue = function(balanceValue, fraction) {
    var multiplier = Math.pow(10, fraction);
    var roundedValue = Math.floor(balanceValue * multiplier) / multiplier;
    var stringValue = balanceValue.toString();
    var decimalIndex = stringValue.indexOf(".");
    if (decimalIndex !== -1) {
        var truncatedValue = stringValue.slice(0, decimalIndex + fraction + 1);
        return parseFloat(truncatedValue);
    }
    return roundedValue;
};


/***/ }),

/***/ 78765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ BankAmendStatusEnums; },
/* harmony export */   "k": function() { return /* binding */ BalanceScopeEnum; }
/* harmony export */ });
var BankAmendStatusEnums;
(function(BankAmendStatusEnums) {
    BankAmendStatusEnums["AMEND_STATUS_UNSPECIFIED"] = "AMEND_STATUS_UNSPECIFIED";
    BankAmendStatusEnums["AMEND_STATUS_IN_PROGRESS"] = "AMEND_STATUS_IN_PROGRESS";
    BankAmendStatusEnums["AMEND_STATUS_REJECTED"] = "AMEND_STATUS_REJECTED";
    BankAmendStatusEnums["AMEND_STATUS_COMPLETED"] = "AMEND_STATUS_COMPLETED";
})(BankAmendStatusEnums || (BankAmendStatusEnums = {}));
var BalanceScopeEnum;
(function(BalanceScopeEnum) {
    BalanceScopeEnum["ALL_RELATED_ACCOUNT"] = "BALANCE_SCOPE_ALL_RELATED_ACCOUNT";
    BalanceScopeEnum["SELECTED_ACCOUNT"] = "BALANCE_SCOPE_SELECTED_ACCOUNT";
})(BalanceScopeEnum || (BalanceScopeEnum = {}));


/***/ }),

/***/ 6430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12461);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);





var alertIcon = {
    success: "alert-success.svg",
    warning: "alert-warning.svg",
    info: "alert-info.svg",
    error: "alert-error.svg"
};
function alertMessage(param) {
    var content = param.content, messageType = param.messageType, alertType = param.alertType, _hasCloseIcon = param.hasCloseIcon, hasCloseIcon = _hasCloseIcon === void 0 ? false : _hasCloseIcon, _duration = param.duration, duration = _duration === void 0 ? 3 : _duration, _onCloseHandler = param.onCloseHandler, onCloseHandler = _onCloseHandler === void 0 ? function() {} : _onCloseHandler;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
    var Icon = null;
    if (alertType === "snackbar" || alertType === "snackbar-dark") {
        Icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/icon/".concat(alertIcon[messageType])
        });
    }
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "notif-close-icon",
        src: "/icon/alert-close.svg",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        }
    }) : null;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].open */ .ZP.open({
        type: messageType,
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "message-".concat(messageType, " alert-").concat(alertType),
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(content)
                    }),
                    closeIcon
                ]
            })
        }),
        duration: duration,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0
        },
        icon: null,
        className: "sysmsg-alert",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        },
        onClose: onCloseHandler
    });
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (alertMessage);


/***/ }),

/***/ 53850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ emittenEndpoint; },
/* harmony export */   "Db": function() { return /* binding */ portfolioEndpoint; },
/* harmony export */   "EN": function() { return /* binding */ bondsEndpoints; },
/* harmony export */   "I6": function() { return /* binding */ orderbookEndpoint; },
/* harmony export */   "KQ": function() { return /* binding */ authEndpoint; },
/* harmony export */   "Li": function() { return /* binding */ orderEndpoint; },
/* harmony export */   "Lr": function() { return /* binding */ termsAndConditionsEndpoint; },
/* harmony export */   "b4": function() { return /* binding */ termsAndConditionsAPI; },
/* harmony export */   "bB": function() { return /* binding */ maintenanceEndpoint; },
/* harmony export */   "bU": function() { return /* binding */ tradingEndpoints; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);


var authEndpoint = {
    authRefresh: "/auth/refresh"
};
var _obj, _obj1;
var portfolioEndpoint = {
    portfolio: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, "/portfolio"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, "/securities/portfolio/v1/list"), _obj),
    portfolioDetail: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, function(symbol) {
        return "/portfolio/detail?symbol=".concat(symbol);
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, function(symbol) {
        return "/portfolio/v2/detail?stock_code=".concat(symbol);
    }), _obj1)
};
var emittenEndpoint = {
    emittenInfo: function(symbol) {
        return "/emitten/".concat(symbol, "/info");
    }
};
var orderbookEndpoint = {
    orderbookCompanies: function(symbol) {
        return "/company-price-feed/v2/orderbook/companies/".concat(symbol);
    }
};
var maintenanceEndpoint = {
    getStatus: "/oms/auth/maintenance/status"
};
var orderEndpoint = {
    bulkCancelByOrderId: "/order/v2/bulk-cancel",
    orderDetail: "/order/v2/detail"
};
var termsAndConditionsEndpoint = {
    getTnCByFeature: function(featureId) {
        return "/tnc/".concat(featureId);
    },
    postTnCAcceptance: function() {
        return "/tnc/acceptance";
    }
};
// terms and condition v2
var termsAndConditionsAPI = {
    getTnCByFeature: function(featureIds) {
        var featuresQs = featureIds.map(function(f) {
            return "feature_ids=".concat(f);
        }).join("&");
        return "/tnc/v2/get?".concat(featuresQs);
    },
    postTnCAcceptance: function() {
        return "/tnc/v2/acceptance";
    }
};
var tradingEndpoints = {
    getTradingInfo: "/trading/info"
};
var bondsEndpoints = {
    postBuy: "/bond/v1/buy",
    getBuyPreview: "/bond/v1/buy/preview",
    getOrderList: "/bond/v1/orders",
    getOrderDetail: function(id) {
        return "/bond/v1/orders/".concat(id);
    },
    getPortfolioList: "/bond/v1/portfolio",
    getPortfolioDetail: function(code) {
        return "/bond/v1/portfolio/".concat(code);
    },
    postSell: "/bond/v1/sell",
    getSellPreview: "/bond/v1/sell/preview"
};


/***/ }),

/***/ 73921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sn": function() { return /* binding */ BondProductTypeEnum; },
/* harmony export */   "qB": function() { return /* binding */ BondTransactionActionEnum; },
/* harmony export */   "ro": function() { return /* binding */ BondOrderStatus; }
/* harmony export */ });
/* unused harmony export BondTaxPreviewTypeEnum */
// Enums
var BondTransactionActionEnum;
(function(BondTransactionActionEnum) {
    BondTransactionActionEnum["UNSPECIFIED"] = "ACTION_UNSPECIFIED";
    BondTransactionActionEnum["BUY"] = "ACTION_BUY";
    BondTransactionActionEnum["SELL"] = "ACTION_SELL";
})(BondTransactionActionEnum || (BondTransactionActionEnum = {}));
var BondTaxPreviewTypeEnum;
(function(BondTaxPreviewTypeEnum) {
    BondTaxPreviewTypeEnum["UNSPECIFIED"] = "TAX_PREVIEW_UNSPECIFIED";
    BondTaxPreviewTypeEnum["SELL"] = "TAX_PREVIEW_SELL";
    BondTaxPreviewTypeEnum["ORDER"] = "TAX_PREVIEW_ORDER";
    BondTaxPreviewTypeEnum["HISTORY"] = "TAX_PREVIEW_HISTORY";
})(BondTaxPreviewTypeEnum || (BondTaxPreviewTypeEnum = {}));
var BondProductTypeEnum;
(function(BondProductTypeEnum) {
    BondProductTypeEnum["UNSPECIFIED"] = "PRODUCT_TYPE_UNSPECIFIED";
    BondProductTypeEnum["FR"] = "PRODUCT_TYPE_FR";
    BondProductTypeEnum["SBN"] = "PRODUCT_TYPE_SBN";
})(BondProductTypeEnum || (BondProductTypeEnum = {}));
var BondOrderStatus;
(function(BondOrderStatus) {
    BondOrderStatus["UNSPECIFIED"] = "BOND_ORDER_STATUS_UNSPECIFIED";
    BondOrderStatus["SUBMITTED"] = "BOND_ORDER_STATUS_SUBMITTED";
    BondOrderStatus["VERIFIED"] = "BOND_ORDER_STATUS_VERIFIED";
    BondOrderStatus["SUCCEEDED"] = "BOND_ORDER_STATUS_SUCCEEDED";
    BondOrderStatus["REJECTED"] = "BOND_ORDER_STATUS_REJECTED";
})(BondOrderStatus || (BondOrderStatus = {}));


/***/ }),

/***/ 13114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ AcceptanceLanguageEnum; },
/* harmony export */   "RD": function() { return /* binding */ SubAccountType; },
/* harmony export */   "el": function() { return /* binding */ TnCFeaturesIDEnum; },
/* harmony export */   "go": function() { return /* binding */ SubAccountStatus; },
/* harmony export */   "hO": function() { return /* binding */ TnCFeatureIDEnum; },
/* harmony export */   "rO": function() { return /* binding */ TnCFeaturePersistMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var AcceptanceLanguageEnum;
(function(AcceptanceLanguageEnum) {
    AcceptanceLanguageEnum["BAHASA"] = "ID";
    AcceptanceLanguageEnum["ENGLISH"] = "EN";
})(AcceptanceLanguageEnum || (AcceptanceLanguageEnum = {}));
var TnCFeatureIDEnum;
(function(TnCFeatureIDEnum) {
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_UNSPECIFIED"] = 0] = "FEATURE_UNSPECIFIED";
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_TRADING_LIMIT"] = 1] = "FEATURE_TRADING_LIMIT";
})(TnCFeatureIDEnum || (TnCFeatureIDEnum = {}));
var SubAccountType;
(function(SubAccountType) {
    SubAccountType["DAY_TRADE"] = "SUB_ACCOUNT_TYPE_DAY_TRADE";
})(SubAccountType || (SubAccountType = {}));
var SubAccountStatus;
(function(SubAccountStatus) {
    SubAccountStatus["ACTIVE"] = "SUB_ACCOUNT_STATUS_ACTIVE";
})(SubAccountStatus || (SubAccountStatus = {}));
var TnCFeaturesIDEnum;
(function(TnCFeaturesIDEnum) {
    TnCFeaturesIDEnum["TRADING_LIMIT"] = "FEATURE_ID_TRADING_LIMIT";
    TnCFeaturesIDEnum["AUTO_ORDER"] = "FEATURE_ID_AUTO_ORDER";
    TnCFeaturesIDEnum["DAY_TRADE"] = "FEATURE_ID_DAY_TRADE";
    TnCFeaturesIDEnum["MULTI_PORTO"] = "FEATURE_ID_MULTIPLE_PORTFOLIO";
})(TnCFeaturesIDEnum || (TnCFeaturesIDEnum = {}));
var _obj;
var TnCFeaturePersistMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.TRADING_LIMIT, "tradingLimitTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.AUTO_ORDER, "autoOrderTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.DAY_TRADE, "dayTradeTnc"), _obj);


/***/ }),

/***/ 38875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ initialSellPreview; },
/* harmony export */   "Ew": function() { return /* binding */ BondBlockerType; },
/* harmony export */   "H1": function() { return /* binding */ BOND_TRANSACTION_CONFIG; },
/* harmony export */   "Im": function() { return /* binding */ BondInfoType; },
/* harmony export */   "MD": function() { return /* binding */ BASE_UNIT_AMOUNT; },
/* harmony export */   "N2": function() { return /* binding */ MAX_UNIT_AMOUNT; },
/* harmony export */   "_y": function() { return /* binding */ BondsModalTypeEnum; },
/* harmony export */   "dX": function() { return /* binding */ initialBuyPreview; },
/* harmony export */   "eM": function() { return /* binding */ bondsErrorTypesMapping; },
/* harmony export */   "gG": function() { return /* binding */ STABLE_EARN_ICON_SRC; },
/* harmony export */   "sW": function() { return /* binding */ FALLBACK_AVATAR_SRC; }
/* harmony export */ });
/* unused harmony exports ModalType, DEBOUNCE_DURATION */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73921);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);



var FALLBACK_AVATAR_SRC = "icon/fr-placeholder.svg";
var STABLE_EARN_ICON_SRC = "icon/fr/icon-stable-earn.svg";
var ModalType;
(function(ModalType) {
    ModalType["UNSPECIFIED"] = "BOND_MODAL_UNSPECIFIED";
    ModalType["TRANSACTION"] = "BOND_MODAL_TRANSACTION";
    ModalType["INFORMATION"] = "BOND_MODAL_INFORMATION";
    ModalType["CONFIRMATION"] = "BOND_MODAL_CONFIRMATION";
    ModalType["BLOCKERS"] = "BOND_MODAL_BLOCKERS";
})(ModalType || (ModalType = {}));
var BondInfoType;
(function(BondInfoType) {
    BondInfoType["UNSPECIFIED"] = "BOND_INFO_UNSPECIFIED";
    BondInfoType["ACCRUED_INTEREST"] = "BOND_INFO_ACCRUED_INTEREST";
    BondInfoType["ACCRUED_INTEREST_SELLER"] = "BOND_INFO_ACCRUED_INTEREST_SELLER";
    BondInfoType["CAPITAL_GAIN_LOSS"] = "BOND_INFO_CAPITAL_GAIN_LOSS";
    BondInfoType["PNL_UNREALIZED"] = "BOND_INFO_PNL_UNREALIZED";
    BondInfoType["TOTAL_DAILY_COUPON"] = "BOND_INFO_TOTAL_DAILY_COUPON";
    BondInfoType["TOTAL_INVESTMENT_PROFIT"] = "BOND_INFO_TOTAL_INVESTMENT_PROFIT";
    BondInfoType["TOTAL_UNIT"] = "BOND_INFO_TOTAL_UNIT";
    BondInfoType["PROJECTED_RETURN"] = "BOND_INFO_PROJECTED_RETURN";
    BondInfoType["PNL_NETT"] = "BOND_INFO_PNL_NETT";
    BondInfoType["TOTAL_PROFIT_NETT"] = "BOND_INFO_TOTAL_PROFIT_NETT";
    BondInfoType["BUYING_PRICE"] = "BOND_INFO_BUYING_PRICE";
    BondInfoType["SELLING_PRICE"] = "BOND_INFO_SELLING_PRICE";
    BondInfoType["PROFIT"] = "BOND_INFO_PROFIT";
    BondInfoType["CASH_ON_HAND"] = "BOND_INFO_CASH_ON_HAND";
    BondInfoType["TAX"] = "BOND_INFO_TAX";
    BondInfoType["BOND_TAX"] = "BOND_INFO_BOND_TAX";
    BondInfoType["USER_COUPON"] = "BOND_INFO_USER_COUPON";
})(BondInfoType || (BondInfoType = {}));
var BondBlockerType;
(function(BondBlockerType) {
    BondBlockerType["UNSPECIFIED"] = "BOND_BLOCKER_UNSPECIFIED";
    BondBlockerType["MARKET_CLOSE"] = "BOND_BLOCKER_MARKET_CLOSE";
    BondBlockerType["UNAVAILABLE"] = "BOND_BLOCKER_UNAVAILABLE";
    BondBlockerType["TEMPORARY_UNAVAILABLE"] = "BOND_BLOCKER_TEMPORARY_UNAVAILABLE";
    BondBlockerType["PRICE_CHANGED"] = "BOND_BLOCKER_PRICE_CHANGED";
    BondBlockerType["MAINTENANCE"] = "BOND_BLOCKER_MAINTENANCE";
    BondBlockerType["SHARIA_VALIDATION"] = "BOND_BLOCKER_SHARIA_VALIDATION";
    BondBlockerType["STABLE_EARN"] = "BOND_BLOCKER_STABLE_EARN";
    BondBlockerType["GENERAL_ERROR"] = "BOND_BLOCKER_GENERAL_ERROR";
})(BondBlockerType || (BondBlockerType = {}));
var BondsModalTypeEnum;
(function(BondsModalTypeEnum) {
    BondsModalTypeEnum["UNSPECIFIED"] = "BOND_MODAL_UNSPECIFIED";
    BondsModalTypeEnum["ASSETS"] = "BOND_MODAL_ASSETS";
    BondsModalTypeEnum["BLOCKERS"] = "BOND_MODAL_BLOCKERS";
    BondsModalTypeEnum["CONFIRMATION"] = "BOND_MODAL_CONFIRMATION";
    BondsModalTypeEnum["HISTORY"] = "BOND_MODAL_HISTORY";
    BondsModalTypeEnum["ORDER"] = "BOND_MODAL_ORDER";
    BondsModalTypeEnum["PORTFOLIO"] = "BOND_MODAL_PORTFOLIO";
    BondsModalTypeEnum["TNC"] = "BOND_MODAL_TNC";
    BondsModalTypeEnum["TRANSACTION"] = "BOND_MODAL_TRANSACTION";
    BondsModalTypeEnum["ORDER_PLACED"] = "BOND_MODAL_ORDER_PLACED";
    BondsModalTypeEnum["COUPON_RECEIPT"] = "BOND_MODAL_COUPON_RECEIPT";
})(BondsModalTypeEnum || (BondsModalTypeEnum = {}));
var _obj;
// Modal Config
var BOND_TRANSACTION_CONFIG = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED, {
    title: "",
    textColor: "#333333",
    content: []
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.BUY */ .qB.BUY, {
    title: "Buy",
    textColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    content: []
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.SELL */ .qB.SELL, {
    title: "Sell",
    textColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sunsetOrange */ .Z.sunsetOrange,
    content: []
}), _obj);
var bondsErrorTypesMapping = {
    product_not_found: BondBlockerType.UNAVAILABLE,
    price_rate_not_found: BondBlockerType.UNAVAILABLE,
    fr_in_record_date_period: BondBlockerType.TEMPORARY_UNAVAILABLE,
    fr_bonds_market_close: BondBlockerType.MARKET_CLOSE,
    price_has_changed: BondBlockerType.PRICE_CHANGED,
    user_sharia_validation: BondBlockerType.SHARIA_VALIDATION,
    stable_earn_cannot_be_sold_outside_bibit: BondBlockerType.STABLE_EARN
};
// Transactions Config
var MAX_UNIT_AMOUNT = 9999999;
var DEBOUNCE_DURATION = 500; // 500ms or 0.5 seconds
var BASE_UNIT_AMOUNT = 1000000; // Base unit amount is 1 million rupiah
// Initial states
var initialBuyPreview = {
    product: {
        type: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondProductTypeEnum.FR */ .Sn.FR,
        id: "",
        name: "",
        min_order: "",
        icon_url: ""
    },
    unit: "0",
    rdn: {
        account_name: "",
        bank: {
            id: "0",
            name: "",
            color_hex: ""
        },
        balance: 0
    },
    settlement_date: "",
    accrued_interest: 0,
    buy_price_amount: 0,
    invested_amount: 0,
    price_rate: 0,
    estimation_amount: 0,
    total_amount: 0,
    fee: {
        stamp_duty: 0,
        tax: 0
    }
};
var initialSellPreview = {
    action: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.SELL */ .qB.SELL,
    available_units: 0,
    units: 0,
    sell_amount: 0,
    accrued_interest: 0,
    amount: 0,
    profit_loss: 0,
    price: {
        deal: 0,
        markup: 0,
        buy: 0,
        sell: 0
    },
    fee: {
        stamp_duty: 0,
        capital_gain_tax: 0,
        accrued_interest_tax: 0,
        commission_fee: 0,
        total_tax: 0,
        tax_percent: 0,
        accrued_interest_exclude_tax: 0,
        estimation_amount_exclude_tax: 0
    },
    product: {
        type: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondProductTypeEnum.FR */ .Sn.FR,
        id: "",
        name: "",
        min_order: "0",
        icon_url: ""
    },
    acquisition: {
        price: 0,
        date: null,
        order_id: ""
    },
    profit_loss_nett: 0,
    daily_accrued_interest: 0,
    invested_amount: 0,
    accrued_interest_exclude_tax: 0,
    estimation_amount_exclude_tax: 0,
    settlement_date: null,
    next_coupon_date: null,
    last_coupon_date: null,
    estimation_sell_amount: 0,
    estimation_disburse_amount: 0,
    capital_gain_loss_nett: 0,
    profit_loss_nett_percentage: 0,
    seller_coupon: 0,
    total_realized_amount: 0,
    total_realized_amount_percentage: 0,
    transaction_pnl: 0
};


/***/ }),

/***/ 10893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59148);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38875);




var initialState = {
    errorCode: 0,
    errorMessage: "",
    errorType: "",
    blockerType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondBlockerType.UNSPECIFIED */ .Ew.UNSPECIFIED
};
var useBondError = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            var blockerType = _constants__WEBPACK_IMPORTED_MODULE_0__/* .bondsErrorTypesMapping */ .eM[type];
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type,
                blockerType: blockerType
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useBondError);


/***/ }),

/***/ 78372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    noAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (exodusInstance);


/***/ }),

/***/ 65906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18364);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var features_securities_withdrawal_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78765);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4621);





var requestNonTrading = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
var requestNonTradingWithAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(undefined, false, false);
var requestTradingURLEncoded = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(undefined, true, true);
var requestTradingV2 = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, false, false);
var RESET_PIN_EXODUS = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/user/setting/pin");
/**
 * Get securities login token
 * @return {APIResponse}
 */ var getAuthToken = function() {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/sekuritas/auth/token"));
};
/**
 * Verify Trading PIN submitted by user
 * @param {string} loginToken - generated from postAuthToken
 * @param {string} pin - PIN submitted by user
 * @return {APIResponse}
 */ var postAuthPIN = function(loginToken, PIN) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/login"), {
            login_token: loginToken,
            pin: PIN
        });
    }
    return requestTradingURLEncoded.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/auth/pin"), {
        loginToken: loginToken,
        pin: PIN
    });
};
/**
 * Get OA Status
 * @return {APIResponse}
 */ var getOAStatus = function() {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/v2/registration/check"));
};
/**
 * Request Forgot Pin
 * @return {APIResponse}
 */ var requestForgotPin = function(identity, channel) {
    return requestNonTradingWithAlert.post("".concat(RESET_PIN_EXODUS, "/phone/send"), {
        identity: identity,
        channel: channel
    });
};
/**
 * Request Forgot Pin when user not login in securitas
 * @param {string} token - generated from requestForgotPin
 * @param {string} otp - user input
 * @return {APIResponse}
 */ var verifyPin = function(token, otp) {
    return requestNonTradingWithAlert.post("".concat(RESET_PIN_EXODUS, "/phone/validate"), {
        token: token,
        otp: otp
    });
};
/**
 * Request Forgot Pin
 * @param {string} token - generated from reset pin page paramater
 * @return {APIResponse}
 */ var verifyToken = function(token) {
    return requestNonTradingWithAlert.post("".concat(RESET_PIN_EXODUS, "/email/validate"), {
        token: token
    });
};
/**
 * Request Forgot Pin
 * @param {string} reset_pin_token - generated from verifyToken
 * @param {string} new_pin - user input
 * @return {APIResponse}
 */ var updatePin = function(reset_pin_token, new_pin) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/auth/pin/reset"), {
            reset_pin_token: reset_pin_token,
            new_pin: new_pin
        });
    }
    return requestTradingURLEncoded.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/auth/resetpin"), {
        reset_pin_token: reset_pin_token,
        new_pin: new_pin
    });
};
/**
 * Request Forgot Pin
 * @param {string[]} symbols - companies
 * @return {APIResponse}
 */ var getAllCorpAction = function(symbols) {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/corpaction/status"), {
        params: {
            symbol: symbols.join(",")
        }
    });
};
/**
 * Get Deposit Guide Data
 * @returns {APIResponse}
 */ var getDepositGuide = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/deposit/guide"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/deposit/guide"));
};
var getAccountBankInfo = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/account/bank"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/account/bank"));
};
var getBankAmendInfo = function() {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/v2/account/bank/amend"));
};
var getForeignBankRules = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/withdrawal/v1/foreign-rules"));
};
var getTradingBalanceDetail = function(params) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var ref = params || {}, accountNumber = ref.accountNumber, scope = ref.scope;
        var queryParam = "";
        if (scope === features_securities_withdrawal_types__WEBPACK_IMPORTED_MODULE_3__/* .BalanceScopeEnum.SELECTED_ACCOUNT */ .k.SELECTED_ACCOUNT) {
            queryParam = "?balance_scope=".concat(scope, "&account_number=").concat(accountNumber);
        }
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/balance/withdrawable").concat(queryParam));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/withdraw/balance"));
};
var cashWithdrawal = function(params) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/withdrawal/v1/withdraw"), {
            amount: params.amount,
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            token_validate_pin: params.validation_pin_token,
            currency_code: params.currency_code,
            signature: params.signature,
            bank_swift_code: params.bank_swift_code,
            transfer_type: params.transfer_type
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/cash/withdraw/request"), params);
};
var cashWithdrawalMultiAccount = function(params) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/withdrawal/v1/withdraw/multi-account"), {
        transactions: params.transactions,
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        token_validate_pin: params.validation_pin_token,
        currency_code: params.currency_code,
        signature: params.signature,
        bank_swift_code: params.bank_swift_code,
        transfer_type: params.transfer_type
    });
};
var getDepositHistory = function(payload) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var queries = new URLSearchParams({
            page: payload.page,
            limit: payload.limit,
            period: payload.period
        });
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/history/deposit?").concat(queries));
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/cash/deposit/history"), payload);
};
var getWithdrawalHistory = function(payload) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var queries = new URLSearchParams({
            page: payload.page,
            limit: payload.limit,
            period: payload.period
        });
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/history/withdraw?").concat(queries));
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/cash/withdraw/history/v2"), payload);
};
var getTransferMethod = function(bankCode) {
    return requestTradingV2.get("withdrawal/v1/option/".concat(bankCode));
};
var checkTransferOperatinStatus = function(param) {
    var bankCode = param.bankCode, transferType = param.transferType;
    return requestTradingV2.get("withdrawal/v1/option/".concat(bankCode, "/confirmation/").concat(transferType));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getAuthToken: getAuthToken,
    postAuthPIN: postAuthPIN,
    getOAStatus: getOAStatus,
    requestForgotPin: requestForgotPin,
    verifyPin: verifyPin,
    verifyToken: verifyToken,
    updatePin: updatePin,
    getAllCorpAction: getAllCorpAction,
    getDepositGuide: getDepositGuide,
    getAccountBankInfo: getAccountBankInfo,
    getBankAmendInfo: getBankAmendInfo,
    getForeignBankRules: getForeignBankRules,
    getTradingBalanceDetail: getTradingBalanceDetail,
    cashWithdrawal: cashWithdrawal,
    cashWithdrawalMultiAccount: cashWithdrawalMultiAccount,
    getDepositHistory: getDepositHistory,
    getWithdrawalHistory: getWithdrawalHistory,
    getTransferMethod: getTransferMethod,
    checkTransferOperatinStatus: checkTransferOperatinStatus
});


/***/ }),

/***/ 76260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: 0,
    errorMessage: "",
    errorType: ""
};
var tradingStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingStore);


/***/ }),

/***/ 11763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ securitiesLocalStorage; }
});

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/constants/securitiesLocalStorage.ts
var SECURITIES_ACCESS_TOKEN = "securitiesAccessToken";
var SECURITIES_REFRESH_TOKEN = "securitiesRefreshToken";
var SECURITIES_ACCOUNT_TYPE = "securitiesAccountType";
var SECURITIES_ACCOUNT_NUMBER = "securitiesAccountNumber";
var SECURITIES_MAIN_ACCOUNT_NUMBER = "securitiesMainAccountNumber";
var TRADE_IS_LOGGED_IN = "tradeIsLogin";
var TRADING_ACCOUNT_TYPE = "tradingAccountType";
var LAST_TRADING_ACCOUNT_TYPE = "lastTradingAccountType";
var TRADING_BROKER = "tradingBroker";


;// CONCATENATED MODULE: ./src/utils/securitiesLocalStorage.ts


function getSecuritiesToken() {
    var tokens = {
        securitiesAccessToken: null,
        securitiesRefreshToken: null
    };
    if ((0,app/* isClient */.C5)()) {
        tokens.securitiesAccessToken = localStorage.getItem(SECURITIES_ACCESS_TOKEN);
        tokens.securitiesRefreshToken = localStorage.getItem(SECURITIES_REFRESH_TOKEN);
    }
    return tokens;
}
function getTradingAccountType() {
    if (!(0,app/* isClient */.C5)()) {
        return null;
    }
    var tradingAccountType = localStorage.getItem(TRADING_ACCOUNT_TYPE);
    return tradingAccountType;
}
function saveSecuritiesToken(param) {
    var securitiesAccessToken = param.securitiesAccessToken, securitiesRefreshToken = param.securitiesRefreshToken;
    if ((0,app/* isClient */.C5)()) {
        localStorage.setItem(SECURITIES_ACCESS_TOKEN, securitiesAccessToken);
        localStorage.setItem(SECURITIES_REFRESH_TOKEN, securitiesRefreshToken);
        localStorage.setItem(TRADE_IS_LOGGED_IN, "true");
        localStorage.setItem(TRADING_ACCOUNT_TYPE, "real");
        localStorage.setItem(LAST_TRADING_ACCOUNT_TYPE, "real");
        localStorage.setItem(TRADING_BROKER, "stockbit");
    }
// Token for flagging that user is logged in
}
function saveSecuritiesAccountInfo(param) {
    var accountType = param.accountType, mainAccountNumber = param.mainAccountNumber, accountNumber = param.accountNumber;
    if ((0,app/* isClient */.C5)()) {
        localStorage.setItem(SECURITIES_ACCOUNT_TYPE, accountType);
        localStorage.setItem(SECURITIES_ACCOUNT_NUMBER, accountNumber);
        localStorage.setItem(SECURITIES_MAIN_ACCOUNT_NUMBER, mainAccountNumber);
    }
}
function getSecuritiesAccountInfo() {
    if ((0,app/* isClient */.C5)()) {
        var accountType = localStorage.getItem(SECURITIES_ACCOUNT_TYPE);
        var accountNumber = localStorage.getItem(SECURITIES_ACCOUNT_NUMBER);
        var mainAccountNumber = localStorage.getItem(SECURITIES_MAIN_ACCOUNT_NUMBER);
        return {
            accountType: accountType,
            accountNumber: accountNumber,
            mainAccountNumber: mainAccountNumber
        };
    }
    return {
        accountType: null,
        accountNumber: null,
        mainAccountNumber: null
    };
}
function switchToVirtualTrading() {
    if ((0,app/* isClient */.C5)()) {
        localStorage.setItem(TRADE_IS_LOGGED_IN, "true");
        localStorage.setItem(TRADING_ACCOUNT_TYPE, "virtual");
        localStorage.setItem(TRADING_BROKER, "virtual");
    }
}
function logoutTrading() {
    var keysToRemove = [
        TRADE_IS_LOGGED_IN,
        TRADING_ACCOUNT_TYPE,
        TRADING_BROKER,
        SECURITIES_ACCESS_TOKEN,
        SECURITIES_REFRESH_TOKEN,
        SECURITIES_ACCOUNT_TYPE,
        SECURITIES_MAIN_ACCOUNT_NUMBER,
        SECURITIES_ACCOUNT_NUMBER,
        LAST_TRADING_ACCOUNT_TYPE, 
    ];
    if ((0,app/* isClient */.C5)()) {
        keysToRemove.forEach(function(key) {
            return localStorage.removeItem(key);
        });
    }
}
/* harmony default export */ var securitiesLocalStorage = ({
    getTradingAccountType: getTradingAccountType,
    getSecuritiesToken: getSecuritiesToken,
    saveSecuritiesToken: saveSecuritiesToken,
    switchToVirtualTrading: switchToVirtualTrading,
    logoutTrading: logoutTrading,
    saveSecuritiesAccountInfo: saveSecuritiesAccountInfo,
    getSecuritiesAccountInfo: getSecuritiesAccountInfo
});


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);